import * as React from 'react';

import { BaseComponent } from '../BaseComponent';
import { LayoutType } from '../../constants/LayoutConstants';
import { HamburgerTab, SidebarModule } from '../../constants/Enums';
import { DebugTab } from './DebugTab';
import { BaseHamburgerTabProps } from './BaseHamburgerTab';
import { HelpFaqTab } from './HelpFaqTab';
import { HelpIconsTab } from './HelpIconsTab';
import { ViewSettingsActions } from '../../actions/ViewSettingsActions';
import { SettingsOptionsTab } from './SettingsOptionsTab';
import { HamburgerNavigation } from './HamburgerNavigation';
import { HelpTab } from './HelpTab';
import { SettingTab } from './SettingTab';
import { PconLoginTab } from './PConLoginTab';

interface HamburgerMenuProps {
    layoutType: LayoutType;
    hamburgerTab: HamburgerTab | null;
    sidebar: SidebarModule;
    sidebarOrientation: string;
    userLanguage: string;
}

export class HamburgerMenu extends BaseComponent<HamburgerMenuProps, {}> {
    public render(): JSX.Element | null  {
        if (this.props.hamburgerTab != null) {
            return (
                <div className={this.getCSSClass()}>
                    <div className="menu-underlay" onClick={this.closeHamburgerMenu}/>
                    {this.leftSide()}
                    <SettingsOptionsTab
                        layoutType={this.props.layoutType}
                        position={(this.props.layoutType !== LayoutType.SMALL ? (this.props.layoutType === LayoutType.DESKTOP ? 2 : 1) : 0)}
                        userLanguage={this.props.userLanguage}
                        sidebarOrientation={this.props.sidebarOrientation}
                    />
                    {this.rightSide()}
                    {this.thirdTab()}
                </div>
            );
        }
        return null;
    }

    protected closeHamburgerMenu = (): void => {
        ViewSettingsActions.changeHamburger(null);
    };

    protected getTab = (nextToMenu: boolean): JSX.Element | null  => {
        switch (this.props.hamburgerTab) {
            case HamburgerTab.DEBUG:
                return (
                    <DebugTab
                        layoutType={this.props.layoutType}
                        userLanguage={this.props.userLanguage}
                        sidebarOrientation={this.props.sidebarOrientation}
                        position={(nextToMenu ? 1 : 0)}
                    />
                );
            case HamburgerTab.SETTINGS:
                return (
                    <SettingTab
                        layoutType={this.props.layoutType}
                        userLanguage={this.props.userLanguage}
                        sidebarOrientation={this.props.sidebarOrientation}
                        position={(nextToMenu ? 1 : 0)}
                    />
                );
            case HamburgerTab.LOGIN:
                return (
                    <PconLoginTab
                        layoutType={this.props.layoutType}
                        userLanguage={this.props.userLanguage}
                        sidebarOrientation={this.props.sidebarOrientation}
                        position={(nextToMenu ? 1 : 0)}
                    />
                );
            case HamburgerTab.HELP:
                return (
                    <HelpTab
                        layoutType={this.props.layoutType}
                        userLanguage={this.props.userLanguage}
                        sidebarOrientation={this.props.sidebarOrientation}
                        position={(nextToMenu ? 1 : 0)}
                    />
                );
            case HamburgerTab.HELP_FAQ:
                if (this.props.layoutType === LayoutType.DESKTOP) {
                    return (
                        <HelpTab
                            layoutType={this.props.layoutType}
                            userLanguage={this.props.userLanguage}
                            sidebarOrientation={this.props.sidebarOrientation}
                            position={(nextToMenu ? 1 : 0)}
                        />
                    );
                }
                return (
                    <HelpFaqTab
                        layoutType={this.props.layoutType}
                        userLanguage={this.props.userLanguage}
                        sidebarOrientation={this.props.sidebarOrientation}
                        position={(nextToMenu ? 1 : 0)}
                    />
                );
            case HamburgerTab.HELP_ICONS:
                if (this.props.layoutType === LayoutType.DESKTOP) {
                    return (
                        <HelpTab
                            layoutType={this.props.layoutType}
                            userLanguage={this.props.userLanguage}
                            sidebarOrientation={this.props.sidebarOrientation}
                            position={(nextToMenu ? 1 : 0)}
                        />
                    );
                }
                return (
                    <HelpIconsTab
                        layoutType={this.props.layoutType}
                        userLanguage={this.props.userLanguage}
                        sidebarOrientation={this.props.sidebarOrientation}
                        position={(nextToMenu ? 1 : 0)}
                    />
                );
            default:
                if (
                    this.props.layoutType !== LayoutType.DESKTOP
                ) {
                    if (nextToMenu) {
                        return (
                            <SettingTab
                                layoutType={this.props.layoutType}
                                userLanguage={this.props.userLanguage}
                                sidebarOrientation={this.props.sidebarOrientation}
                                position={(nextToMenu ? 1 : 0)}
                            />
                        );
                    }
                    return (
                        <HamburgerNavigation
                            layoutType={this.props.layoutType}
                            userLanguage={this.props.userLanguage}
                            sidebarOrientation={this.props.sidebarOrientation}
                            position={(nextToMenu ? 1 : 0)}
                        />
                    );
                }
        }
        return null;
    };

    protected getSingleTab = (): JSX.Element => {
        const props: BaseHamburgerTabProps = {
            layoutType: this.props.layoutType,
            userLanguage: this.props.userLanguage,
            sidebarOrientation: this.props.sidebarOrientation,
            position: -1
        };
        switch (this.props.hamburgerTab) {
            case HamburgerTab.DEBUG:
                return <DebugTab {...props}/>;
            case HamburgerTab.SETTINGS:
                return <SettingTab  {...props}/>;
            case HamburgerTab.LOGIN:
                return <PconLoginTab {...props}/>;
            case HamburgerTab.HELP:
                return <HelpTab {...props}/>;
            case HamburgerTab.HELP_FAQ:
                return <HelpTab {...props}/>;
            case HamburgerTab.HELP_ICONS:
                if (true) {
                    return <HelpTab {...props}/>;
                }
                return <HelpIconsTab {...props}/>;
            default:
                return <HamburgerNavigation {...props}/>;
        }
    };

    protected getCSSClass: () => string = () => {
        let result: string = 'hamburger-menu';

        if (this.props.sidebarOrientation === 'right') {
            result += ' on-right-side';
        }

        return result;
    };

    protected leftSide(): JSX.Element | null  {
        if (this.props.layoutType !== LayoutType.SMALL) {
            return (
                <HamburgerNavigation
                    layoutType={this.props.layoutType}
                    userLanguage={this.props.userLanguage}
                    sidebarOrientation={this.props.sidebarOrientation}
                    position={0}
                />
            );
        }
        return this.getTab(false);
    }

    protected rightSide(): JSX.Element | null  {
        if (this.props.layoutType !== LayoutType.SMALL) {
            return this.getTab(true);
        }
        return null;
    }

    protected thirdTab(): JSX.Element | null  {
        if (
            false &&
            this.props.layoutType === LayoutType.DESKTOP
        ) {
            switch (this.props.hamburgerTab) {
                case HamburgerTab.HELP_FAQ:
                    return (
                        <HelpFaqTab
                            layoutType={this.props.layoutType}
                            userLanguage={this.props.userLanguage}
                            sidebarOrientation={this.props.sidebarOrientation}
                            position={2}
                        />
                    );
                case HamburgerTab.HELP_ICONS:
                    return (
                        <HelpIconsTab
                            layoutType={this.props.layoutType}
                            userLanguage={this.props.userLanguage}
                            sidebarOrientation={this.props.sidebarOrientation}
                            position={2}
                        />
                    );
                default:
                    break;
            }
        }
        return null;
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/hamburgermenu/HamburgerMenu.tsx